import { provideHttpClient, withFetch } from '@angular/common/http';
import { APP_INITIALIZER, ApplicationConfig, provideZonelessChangeDetection } from '@angular/core';
import {
    provideRouter,
    withEnabledBlockingInitialNavigation,
    withInMemoryScrolling,
} from '@angular/router';
import Aura from '@primeuix/themes/aura';
import { MessageService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';
import { appRoutes } from './app.routes';
import { AuthService } from '@/app/services/auth.service';

export const appConfig: ApplicationConfig = {
    providers: [
        provideRouter(
            appRoutes,
            withInMemoryScrolling({
                anchorScrolling: 'enabled',
                scrollPositionRestoration: 'enabled',
            }),
            withEnabledBlockingInitialNavigation(),
        ),
        provideHttpClient(withFetch()),
        provideZonelessChangeDetection(),
        providePrimeNG({ theme: { preset: Aura, options: { darkModeSelector: '.app-dark' } } }),
        // One app-wide toast channel: the single `<p-toast>` lives in AppComponent
        // and every producer (services via NotificationService, components via
        // MessageService) writes to this instance. Do NOT re-provide
        // MessageService in a component — that creates a second bus whose
        // messages no toast renders.
        MessageService,
        {
            provide: APP_INITIALIZER,
            useFactory: (auth: AuthService) => () => auth.restoreSession(),
            deps: [AuthService],
            multi: true,
        },
    ],
};
